<script>

export default {

  name: 'FarmSelector',
  computed: {
    numberOfFields() {
      let numberOfFields = 0
      this.farmFiltered.forEach((element) => {
        numberOfFields += element.fields.length
      })
      return numberOfFields
    }
  },

  props: {
    farms: {
      type: Object,
      required: false,
      default: function () {
        return null
      }
    },
    farmId: {
      type: Number,
      required: false,
    },
    userId: {
      type: Number,
      required: true,
    },
    isRecruiter: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      selected: null
    };
  },

  created() {
    if (this.farmId) {
      this.selected = this.farmId
    }
  },

  methods: {
    redirectToFarm() {
      let data
      let route
      if (this.selected > 0) {
        data = {
          user_id: this.userId,
          farmIndex: this.selected
        }
        route = '/'
      } else {
        data = {user_id: this.userId,}
        route = '/farms/create'
      }

      let urlParams = '?' + this.urlParams(data)
      location.href = route + urlParams
    },

    urlParams(myData) {
      let out = [];
      for (let key in myData) {
        if (myData.hasOwnProperty(key)) {
          out.push(key + '=' + encodeURIComponent(myData[key]));
        }
      }
      return out.join('&');
    },
  },
};

</script>

<template>
  <div>
    <select
        v-model="selected"
        @change="redirectToFarm"
        class="bg-grey italic text-white border-b border-grey-light w-full py-2 px-3 leading-tight focus:outline-none focus:ring">
      <option disabled :value="null">
        Select a Farm
      </option>
      <option v-for="(farm,id) in farms" :value="id">
        {{ farm }}
      </option>

      <option value="-1" v-if="!isRecruiter">
        Create New
      </option>
    </select>
  </div>
</template>